import { Router } from '@angular/router';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { SeguimientoCertificadosComponent } from '../../seguimiento-certificados/seguimiento-certificados.component';
import { ClaveUnicaComponent } from '../../claveunica/claveunica.component';


@Component({
  selector: "page-auxUrlcert",
  templateUrl: "auxUrlcert.component.html",
  styleUrls: ["./auxUrlcert.component.css"]
})

export class AuxUrlCertComponent {
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;

  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
  public solicitudesPago = [
    "Certificado de Número",
    "Certificado de Afectación a Utilidad Pública (No Expropiación)",
    "Certificado de Informes Previos",
    "Certificado de Localización",
    "Acreditación de la(s) Recepción(es) de Edificación aprobadas en una propiedad, según la información del Archivo DOM.",
    "Acreditación de la calidad de una Vivienda Económica acogida a D.F.L.2 , según la información del Archivo DOM.",
    "Acreditación de la calidad de una Vivienda Social , según la información del Archivo DOM."
  ]

  constructor(
    private dialog: MatDialog,
    private _router: Router,
  ) {

  }

  seguimiento() {
    this.dialog.open(SeguimientoCertificadosComponent);
  }

  cerrar_vista() {
    this._router.navigate([`/inicio`]);
  }
  sign(tipo) {
    if (sessionStorage.getItem("identity-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'solicitud_vivienda') {
        this._router.navigate([`/solicitud_vivienda`]);
      }
      else if (tipo == 'seguimiento-certificados') {
        this._router.navigate([`/seguimiento-certificados`]);
      }
      else if (tipo == 'certificados') {
        this._router.navigate([`/certificados`]);
      }

    } else {
      this.dialog.closeAll();
      if (tipo == 'solicitud_vivienda') {
        // console.log("expediente 1");
        this._router.navigate([`/solicitud_vivienda`]);
      }
      else if (tipo == 'seguimiento-certificados') {
        this.dialog.open(ClaveUnicaComponent, { data: "/seguimiento-certificados" })
        //this._router.navigate([`/seguimiento-certificados`]);
      }
      else if (tipo == 'certificados') {
        this.dialog.open(ClaveUnicaComponent, { data: "/certificados" })
        //this._router.navigate([`/certificados`]);
      }
    }
  }

}
